module.exports = __webpack_public_path__ + "img/BrandImg2.f98c1af4.png";